import React, { useMemo } from "react";
import { parseSummaryBlocks } from "@/utils/transcriptHelpers";

const SummaryFormattedContent = ({ text, isDark, compact = false }) => {
  const blocks = useMemo(() => parseSummaryBlocks(text), [text]);

  if (!blocks.length) {
    return (
      <p className={`text-sm ${isDark ? "text-slate-500" : "text-gray-500"}`}>
        Özet metni yok.
      </p>
    );
  }

  const paragraphClass = compact
    ? `text-sm leading-6 break-words ${isDark ? "text-slate-300" : "text-gray-700"}`
    : `text-[15px] leading-7 break-words ${isDark ? "text-slate-200" : "text-gray-800"}`;

  const headingClass = compact
    ? `text-xs font-semibold uppercase tracking-wide ${isDark ? "text-emerald-300" : "text-emerald-700"}`
    : `text-sm font-semibold ${isDark ? "text-emerald-300" : "text-emerald-800"}`;

  const listItemClass = compact
    ? `text-sm leading-6 break-words ${isDark ? "text-slate-300" : "text-gray-700"}`
    : `text-[15px] leading-7 break-words ${isDark ? "text-slate-200" : "text-gray-800"}`;

  const bulletClass = isDark ? "bg-emerald-400" : "bg-emerald-500";
  const numberClass = isDark
    ? "bg-slate-800 text-emerald-300 ring-1 ring-slate-700"
    : "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100";

  return (
    <div className={compact ? "space-y-2.5" : "space-y-4"}>
      {blocks.map((block, index) => {
        if (block.type === "heading") {
          return (
            <h4 key={`h-${index}`} className={`${headingClass} pt-1`}>
              {block.text}
            </h4>
          );
        }

        if (block.type === "paragraph") {
          return (
            <p key={`p-${index}`} className={paragraphClass}>
              {block.text}
            </p>
          );
        }

        if (block.type === "bullet") {
          return (
            <ul key={`b-${index}`} className="space-y-2.5">
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex} className="flex gap-3 items-start">
                  <span className={`mt-[0.55rem] w-1.5 h-1.5 rounded-full shrink-0 ${bulletClass}`} />
                  <span className={listItemClass}>{item}</span>
                </li>
              ))}
            </ul>
          );
        }

        if (block.type === "numbered") {
          return (
            <ol key={`n-${index}`} className="space-y-2.5">
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex} className="flex gap-3 items-start">
                  <span className={`inline-flex items-center justify-center w-5 h-5 rounded-md text-[10px] font-bold shrink-0 mt-0.5 ${numberClass}`}>
                    {itemIndex + 1}
                  </span>
                  <span className={listItemClass}>{item}</span>
                </li>
              ))}
            </ol>
          );
        }

        return null;
      })}
    </div>
  );
};

export default SummaryFormattedContent;
